import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { LanguageConst } from '../../../utils/resources/languageconst';

export interface FloatingTextCSSStyle extends UIComponentCSSStyle
{
    getTextCSSStyle(isFloatingLabel: boolean): object;
    getErrorCSSStyle(): object;
    getErrorTextDivCSSStyle(): object;
    getErrorTextCSSStyle(language:any): object;
}

export class FloatingTextCSSStyleImpl extends UIComponentCSSStyleImpl implements FloatingTextCSSStyle
{
    getWrapperCSSStyle(): object 
    {
        return {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            marginTop: "30px",
        };
    }

    getTextCSSStyle(isFloatingLabel: boolean): object 
    {
        console.log("isFloatingLabel: " + isFloatingLabel);
        if(isFloatingLabel)
        {
            return {
                fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH? this.getResources().getFont(Fonts.h9):"16px",
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "100%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
        else
        {
            return {
                fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?this.getResources().getFont(Fonts.h9):"16px",
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "100%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
    }
    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h9),
            color: this.getResources().getColor(Colors.color_4),
            height: "30px",
            bottom: "3px",
            textDecoration: "none",
            borderTop: 0,
            borderRight:0,
            fontWeight: 500,
            borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
            borderLeft:0,
            outline: "none",
            fontFamily: this.getResources().getFontFamily()

        };
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
            width:"100%",
           display: "flex",
        
        };
    }

    getErrorTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_12),
            fontSize: this.getResources().getFont(Fonts.h5),
            margin:'3px 0px 0px auto',
            height:'auto',
            fontFamily:this.getResources().getFontFamily()

        };
    } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/floatingtextcss.tsx